import { Icon, IconProps } from "@chakra-ui/react";
import { LuClipboardList } from "react-icons/lu";

export default function Form(props: IconProps) {
  return <Icon as={LuClipboardList} {...props} />;
}
